import withStateHandlers from 'recompose/withStateHandlers';
import { StateHandlerMap } from 'recompose';

type IState = {
    toggle: boolean;
};

interface IUpdaters extends StateHandlerMap<IState> {
    switchToggle(): Partial<IState>;
    onToggle(): Partial<IState>;
    offToggle(): Partial<IState>;
}

export type IToggleEnhacerProps = {
    switchToggle(): void;
    onToggle(): void;
    offToggle(): void;
} & IState;

export default withStateHandlers<IState, IUpdaters>(
    {
        toggle: false,
    },
    {
        switchToggle: state => () => ({ toggle: !state.toggle }),
        onToggle: () => () => ({ toggle: true }),
        offToggle: () => () => ({ toggle: false }),
    },
);
